import { SupportedBankCountry, SupportedBankTransferType } from '../../../constants/bank.constants';

export class SupportedBankPaymentMethod {
    public country: SupportedBankCountry;
    public transferType: SupportedBankTransferType;

    constructor(obj?: {
        country?: SupportedBankCountry;
        transferType?: SupportedBankTransferType;
    }) {
        if (obj != null) {
            this.country = typeof obj.country === 'undefined' ? this.country : obj.country;
            this.transferType =
                typeof obj.transferType === 'undefined' ? this.transferType : obj.transferType;
        }
    }
}
